"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  core: {
    propertyEditor: {
      fieldIsRequired: 'This field is required.',
      specificFieldIsRequired: 'The {0} is required.',
      fieldIsEmptyOrInvalid: 'Enter a valid {fieldName}',
      readAgreement: 'Read the agreement',
      onlyUniqueColors: 'Only unique colors are allowed.',
      fileUpload: {
        "delete": 'DELETE',
        deleteConfirmation: 'Are you sure you want to delete',
        uploadDropZoneText: 'Drop your file or',
        close: 'Close',
        tos: 'Terms of service'
      }
    }
  }
});